import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import axios from 'axios';
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { HttpHeaders } from '~/constants';
import { ErrorResponse } from '~/infra/ErrorResponse';
import { selectors } from './state-selectors';
export var APIHost = /*#__PURE__*/ function(APIHost) {
    APIHost["AI"] = "ai";
    APIHost["KYB"] = "kyb";
    APIHost["Plaid"] = "plaid";
    APIHost["Scout"] = "scout";
    APIHost["Mgmt"] = "mgmt";
    APIHost["Cato"] = "cato";
    APIHost["External"] = "external";
    /** @deprecated */ APIHost["Old"] = "old";
    return APIHost;
}({});
export function initSendRequest(param) {
    let { getState, getCookie, onCookieChange, onLogout, onNoAccess, onReportToSentry } = param;
    return function sendRequest(options) {
        const { method, params = {}, data = {}, apiHost, disableAuth, forceAuthorizationHeader, authToken, url, disableSentry, urlForSentry, config, disable403Handling } = options;
        const { apiHost: apiHostname, apiGatewayHost, useAuthorizationHeader } = getState().session;
        const apiGatewayHosts = [
            "plaid",
            "scout",
            "cato",
            "kyb",
            "external",
            "ai",
            "mgmt"
        ];
        const actualHost = apiGatewayHosts.includes(apiHost) ? apiGatewayHost : apiHostname;
        const fullUrl = actualHost + url;
        const prevCookie = getCookie();
        const axiosConfig = _object_spread_props(_object_spread({}, config), {
            withCredentials: true,
            params
        });
        if (!axiosConfig.headers) {
            axiosConfig.headers = {};
        }
        if (!axiosConfig.headers[HttpHeaders.ContentType]) {
            axiosConfig.headers[HttpHeaders.ContentType] = 'application/json';
        }
        const apiHostHeaderHosts = [
            "plaid",
            "scout",
            "kyb",
            "cato",
            "ai",
            "mgmt"
        ];
        if (apiHostHeaderHosts.includes(apiHost)) {
            axiosConfig.headers = _object_spread_props(_object_spread({}, axiosConfig.headers), {
                ['x-api-host']: apiHost
            });
        }
        const actualAuthToken = (disableAuth || !useAuthorizationHeader) && !forceAuthorizationHeader ? null : authToken !== null && authToken !== void 0 ? authToken : getState().authToken;
        if (actualAuthToken) {
            axiosConfig.headers.Authorization = "Bearer ".concat(actualAuthToken);
        }
        if (window._sessionId) {
            axiosConfig.headers[HttpHeaders.SessionId] = window._sessionId;
        }
        const requestId = generateUniqueId('request');
        axiosConfig.headers[HttpHeaders.RequestId] = requestId;
        const request = axios.request(_object_spread_props(_object_spread({
            method,
            url: fullUrl
        }, axiosConfig), {
            data
        }));
        return request.then((response)=>{
            if (prevCookie !== getCookie()) {
                onCookieChange();
            }
            return response;
        }).catch((err)=>{
            const e = new ErrorResponse(err);
            const is401 = e.status === 401;
            const is403ForReviewer = e.status === 403 && selectors.user.isReviewer(getState());
            const isImpersonating = !!selectors.impersonatingAs(getState());
            if (is401 || is403ForReviewer) onLogout();
            if (!disable403Handling && e.status === 403) onNoAccess();
            const disableSentryReporting = isImpersonating || is401 || is403ForReviewer || typeof disableSentry === 'function' && disableSentry(e);
            if (!disableSentryReporting && e.status) {
                onReportToSentry({
                    message: "Request (".concat(method.toUpperCase(), " ").concat(urlForSentry || fullUrl, ") failed with status code ").concat(e.status),
                    requestId,
                    method,
                    url: fullUrl,
                    responseBody: e.body ? JSON.stringify(e.body) : ''
                });
            }
            throw err;
        });
    };
}
